import { useContext } from 'react'

import { UserContext } from './UserContext'
import { UserContextProps } from './interfaces'

export const useUser = (): UserContextProps => useContext(UserContext)
